import { useState } from "react";
import { NavLink, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import HeroImg from "../../assets/images/serviceportal.png";
import { CiSearch } from "react-icons/ci";
import ServicePortal from "../../assets/images/fis-logo.svg";
import { AppDispatch, RootState } from "@store/store";
import useServicePortal from "@hooks/useServicePortal";
import { setTokenData } from "@redux/auth/tokenData";
import CMS from "@assets/icons/cms.svg";
import User from "@assets/icons/user.svg";
import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io";
import Footer from "@components/footer/Footer";
import { GoLinkExternal } from "react-icons/go";
import { CONTACT_US_URL, portalConfig } from "@utils/servicePortalUtils";
import { IoEye } from "react-icons/io5";
import Button from "@components/ui/Button";
import { ROUTES } from "@routes/RouteConstant";
import { logout } from "@services/userModule/UserService";
import { setAuthenticated } from "@redux/auth/auth";
const ClientServicePortal = () => {
  const navigate = useNavigate();
  const tokenData = useSelector(
    (state: RootState) => state.tokenData.tokenData,
  );
  const user = useSelector((state: RootState) => state.user);

  const dispatch: AppDispatch = useDispatch();

  const [search, setSearch] = useState("");

  const { allowedPortals, allowedAdminHelpDesk } = useServicePortal();

  const handlePortalClick = (portal: string) => {
    const config = portalConfig[portal];

    if (!config) return;

    if (config.action === "REDITRECT_CMS" && config.url) {
      // const redirectUrl = `${config.url}${tokenData.token}`;
      const redirectUrl = `${config.url}`;
      window.open(redirectUrl, "_blank");
      return;
    }

    if (config.url) {
      window.open(config.url, "_blank");
    }
  };

  const handleHelpDeskLogin = () => {
    dispatch(
      setTokenData({
        // token: tokenData.token,
        // tokenexpires: tokenData.tokenexpires,
        portalProtected: true,
      }),
    );
    window.open(ROUTES.DASHBOARD, "_blank");
  };

  const handleLogout = () => {
    logout().then(() => {});
    dispatch(
      setTokenData({
        token: "",
        tokenexpires: "",
        portalProtected: false,
      }),
    );
    dispatch(setAuthenticated(false));
    navigate(ROUTES.LOGIN, { replace: true });
  };

  const allowedPortalsFiltered = allowedPortals.filter(
    (p) =>
      p.title.toLowerCase().includes(search.toLowerCase()) ||
      p.description.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <section
      className={`portal ${
        allowedPortalsFiltered.length === 0 ? "no-portals" : ""
      }`}
    >
      <header className="portal__header">
        <div className="logo">
          <img src={ServicePortal} alt="FIS Logo" />
        </div>

        <nav className="nav">
          {allowedAdminHelpDesk && (
            <button className="btn primary" onClick={handleHelpDeskLogin}>
              Admin & Support Login <GoLinkExternal />
            </button>
          )}
          <div className="nav-links">
            <div className="dropdown">
              <NavLink to="#">
                Portals <IoIosArrowDown />
              </NavLink>
              <ul className="dropdown-nav-menu">
                {allowedPortals.map((p) => (
                  <li
                    key={p.key}
                    className={
                      portalConfig[p.key]?.options ? "has-submenu" : ""
                    }
                  >
                    <button onClick={() => handlePortalClick(p.key)}>
                      <span>{p.title}</span>

                      {portalConfig[p.key]?.options && <IoIosArrowForward />}
                    </button>

                    {portalConfig[p.key]?.options && (
                      <ul className="sub-dropdown">
                        {portalConfig[p.key]?.options?.map((option) => (
                          <li key={option.label}>
                            <button
                              onClick={() => window.open(option.url, "_blank")}
                            >
                              {option.label}
                            </button>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
            </div>
            <NavLink to={CONTACT_US_URL} target="_blank">
              Contact Us
            </NavLink>
            <div className="divider" />
            <div className="dropdown">
              <NavLink to="#" className="user-link">
                {user?.contactInfo?.name}
                <img src={User} alt="User" />
              </NavLink>
              <ul className="dropdown-nav-menu">
                <li>
                  <button onClick={handleLogout}>Logout</button>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>

      <div className="hero-shape">
        <div className="portal__hero">
          <div className="portal__content">
            <div className="portal__left">
              <h1>
                FIS<sup>®</sup> Everlink™ Portal
              </h1>
              <p>
                Centralized access to all FIS Everlink portals in one place.
              </p>

              <div className="search">
                <CiSearch />
                <input
                  type="text"
                  placeholder="Search"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>

            <div className="portal__right">
              <div className="image-wrapper">
                <img src={HeroImg} alt="Portal" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="portal__portals">
        {allowedPortalsFiltered.length > 0 ? (
          <>
            <h2>Available Portals</h2>
            <p>Please select the portal you wish to access to proceed</p>
            <div className="portal-boxes">
              {allowedPortalsFiltered.map((p) => (
                <div className="portal-box" key={p.key}>
                  <div
                    className="portal-card"
                    onClick={() => handlePortalClick(p.key)}
                  >
                    <div className="card-content">
                      <div className="icon">
                        <img src={CMS} alt={`${p.key} icon`} />
                      </div>

                      <div className="name">{p.title}</div>
                      <div className="desc">{p.description}</div>
                    </div>
                    {portalConfig[p.key]?.options && (
                      <div className="hover-overlay">
                        {portalConfig[p.key]?.options?.map((option) => (
                          <Button
                            key={option.label}
                            type="button"
                            text={option.label}
                            variant="primary"
                            onClick={() => window.open(option.url, "_blank")}
                            size="medium"
                            icon={<IoEye />}
                          />
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </>
        ) : (
          <h2>No Available Portals</h2>
        )}
      </div>
      <div
        className={`portal__footer ${
          allowedPortalsFiltered.length === 0 ? "footer-disclaimer" : ""
        }`}
      >
        <p className="disclaimer">
          Everlink Payment Services Inc., is a registered money services
          business and wholly owned subsidiary of FIS. Everlink Payment Services
          Inc is the provider of services described in this presentation
        </p>
        <Footer />
      </div>
    </section>
  );
};

export default ClientServicePortal;
